import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

const { blue } = colorsPalettes;

export const Container = styled(FlexRow)`
    align-items: center;
    gap: 12px;
    padding: 16px;
    color: ${blue[400]};
    background-color: ${blue[50]};
    border-radius: 6px;
`;

export const InfoContainer = styled(FlexColumn)`
    gap: 4px;
`;

export const Title = styled.span`
    ${setFontVariant("subtitle2")};
`;

export const Description = styled(FlexRow)`
    align-items: center;
    gap: 4px;
    ${setFontVariant("caption")};
`;

export const TimeBadge = styled(FlexRow)`
    align-items: center;
    gap: 4px;
    padding: 6px 8px;
    margin-left: auto;

    background-color: ${blue[100]};
    border-radius: 6px;
    ${setFontVariant("subtitle1")};
`;
